import AbstractView from 'abstracts/AbstractView';
import Screen from "controllers/Screen";
import TransitionLines from "../../../partials/transition-lines/js/TransitionLines";


export default class TransitionProjectCardTitle extends TransitionLines {


	constructor($wrapper) {
		super($wrapper);
	}


	init() {
		this.$wrapper.closest('a').addClass('transition-link');
		this.linesClass = 'transition-line transition-link-line';
		super.init();
	}

	update() {
		super.update();
		$(this.split.lines).each((index, item) => {
			item.setAttribute('data-text', item.textContent);
		});
	}
}
